/*
 * Applies values for breakpoints from props according to `keys` argument, always returns an object
 * `fillValues` flag defines whether missing values should be filled or not
 * NOTE: it's made dumb on purpose to reduce cyclomatic complexity
 */
import { sizes } from '../breakpoints';
import { isDefined } from './defined';
export var applyForBreakpoints = function applyForBreakpoints(props, keys, fillValues) {
  var _props$keys$;

  if (keys === void 0) {
    keys = sizes;
  }

  if (fillValues === void 0) {
    fillValues = true;
  }

  var xs = (_props$keys$ = props[keys[0]]) != null ? _props$keys$ : props['_']; // hack to support styled-system like objects: https://styled-system.com/responsive-styles/#using-objects

  var sm = props[keys[1]];
  var md = props[keys[2]];
  var lg = props[keys[3]];
  var xl = props[keys[4]];
  var result = {
    xs: xs
  };

  if (!fillValues) {
    if (isDefined(sm)) {
      result.sm = sm;
    }

    if (isDefined(md)) {
      result.md = md;
    }

    if (isDefined(lg)) {
      result.lg = lg;
    }

    if (isDefined(xl)) {
      result.xl = xl;
    }
  } else {
    var _ref, _ref2, _ref3, _ref4, _ref5, _ref6;

    result.sm = sm != null ? sm : xs;
    result.md = (_ref = md != null ? md : sm) != null ? _ref : xs;
    result.lg = (_ref2 = (_ref3 = lg != null ? lg : md) != null ? _ref3 : sm) != null ? _ref2 : xs;
    result.xl = (_ref4 = (_ref5 = (_ref6 = xl != null ? xl : lg) != null ? _ref6 : md) != null ? _ref5 : sm) != null ? _ref4 : xs;
  }

  return result;
};